import React, { useCallback, useId } from 'react';
import { useTranslation } from 'react-i18next';
import { useController, useFormContext } from 'react-hook-form';
import FormElement from '@wix/da-ds/pkg/formControls/layouts/FormElement';
import InputLabelText from '@wix/da-ds/pkg/formControls/lego/InputLabelText';
import InputErrorMessage from '@wix/da-ds/pkg/formControls/lego/InputErrorMessage';
import DescriptionEditor from '@wix/da-shared-react/pkg/DescriptionEditor';
import { OriginalDeviationFieldName } from '../../types';
import { UseEditorOptions } from '@wix/da-editor-tiptap/pkg/hooks/useEditor';

interface Props {}

const DescriptionField: React.FC<Props> = () => {
  const { t } = useTranslation();
  const id = useId();
  const { control, errors, setValue, getValues } = useFormContext();
  const {
    field: { value },
  } = useController({
    name: OriginalDeviationFieldName.DESCRIPTION,
    control,
  });
  const error = errors[OriginalDeviationFieldName.DESCRIPTION];

  const handleChange: UseEditorOptions['onEditorChange'] = useCallback(
    editorState =>
      setValue(
        OriginalDeviationFieldName.DESCRIPTION,
        getValues(OriginalDeviationFieldName.DESCRIPTION),
        {
          shouldDirty: true,
        }
      ),
    [getValues, setValue]
  );

  return (
    <FormElement
      inputId={id}
      label={
        <InputLabelText isRequired>
          {t('originalDeviationPopup.form.description.label')}
        </InputLabelText>
      }
      noBottomSpacing
    >
      <DescriptionEditor
        placeholder={t('originalDeviationPopup.form.description.placeholder')}
        initialContent={value}
        onChange={handleChange}
      />
      {error && <InputErrorMessage>{error.message}</InputErrorMessage>}
    </FormElement>
  );
};
DescriptionField.displayName = 'DescriptionField';

export default DescriptionField;
